import React from 'react';
import './cardWrapper.scss';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';

const SummaryCardWrapper = (props) => {
  const {
    title,
    total,
    ird = false,
    subTitle,
    isInformation,
    background = '#fff',
    className = '',
  } = props;

  return (
    <div className={`${className} col-3 `}>
      <div
        className={
          !ird
            ? 'smallCard'
            : title === 'Total Revenue'
            ? ' analytic-summary-card-ird analytic-summary-total-revenue-card-ird'
            : 'analytic-summary-card-ird'
        }
        style={{ background }}
      >
        <div className='d-flex flex-column smallhead'>
          <div className={!ird ? 'analytic-summary-card-title' : 'analytic-summary-card-ird-title'}>
            {title}
          </div>
          {subTitle && <span className='col-12 descriptionText pt-1'>{subTitle}</span>}
          {isInformation && (
            <div>
              <Tooltip title={isInformation} placement='right'>
                <InfoIcon style={{ fontSize: '15px' }} className='mr-2' />
              </Tooltip>
            </div>
          )}
        </div>
        <div className={!ird ? 'analytic-summary-card-total' : 'analytic-summary-card-ird-total'}>
          {total}
        </div>
      </div>
    </div>
  );
};

export default SummaryCardWrapper;
